import { useBenefitEnrollment } from "#/components/context/enrollment/BenefitEnrollmentContext"
import { providerNotListedValue } from "."
import { TradingPartner } from "../types"
import { useIntl } from "react-intl"

/** `tradingPartnerPk` of the synthetic "Provider not listed" option. */
export const providerNotListedPk = -1

export interface UseTradingPartners {
  options: { label: string; value: number }[]
  availableTradingPartners: TradingPartner[]
}

export function useTradingPartners(): UseTradingPartners {
  const { availableTradingPartners } = useBenefitEnrollment()
  const intl = useIntl()

  // Build the list locally rather than pushing the synthetic row onto availableTradingPartners,
  // which is the redux insuranceSyncInfo state (and would freeze the label to the first locale).
  const tradingPartners: TradingPartner[] = [
    ...(availableTradingPartners ?? []).filter((tp) => tp.id !== providerNotListedValue),
    {
      id: providerNotListedValue,
      description: intl.formatMessage({ defaultMessage: "Provider not listed" }),
      tradingPartnerPk: providerNotListedPk
    }
  ]

  const options = tradingPartners.map((tradingPartner) => ({
    label: tradingPartner.description,
    value: tradingPartner.tradingPartnerPk
  }))

  return {
    options,
    availableTradingPartners: tradingPartners
  }
}
